import React from 'react'
import CaluButton from '@/components/styledComponents/CaluButton'
import { Tooltip } from '@mui/material'

const FAQ = () => {
  return (
    <Tooltip title="Preguntas frecuentes">
      <a href="/preguntas-frecuentes" target="_blank" rel="noopener noreferrer">
        <CaluButton size={'small'} color={'primary'}>
          Ayuda
        </CaluButton>
      </a>
    </Tooltip>
  )
}

export default FAQ
